function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["ref"],
  _excluded2 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { focusSafely as $6a99195332edec8b$export$80f3e147d781571c } from "./focusSafely.module.js";
import { useSyncRef as $h8xso$useSyncRef, useObjectRef as $h8xso$useObjectRef, mergeProps as $h8xso$mergeProps } from "@react-aria/utils";
import $h8xso$react, { useContext as $h8xso$useContext, useRef as $h8xso$useRef, useEffect as $h8xso$useEffect } from "react";
import { useFocus as $h8xso$useFocus, useKeyboard as $h8xso$useKeyboard } from "@react-aria/interactions";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/(0, $h8xso$react).createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
  var context = (0, $h8xso$useContext)($e6afbd83fe6ebbd2$var$FocusableContext) || {};
  (0, $h8xso$useSyncRef)(context, ref);
  // eslint-disable-next-line
  var _ = context.ref,
    otherProps = _objectWithoutProperties(context, _excluded);
  return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */
function $e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
  var children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var objRef = (0, $h8xso$useObjectRef)(ref);
  var context = _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: objRef
  });
  return /*#__PURE__*/(0, $h8xso$react).createElement($e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
    value: context
  }, children);
}
var $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5 = /*#__PURE__*/(0, $h8xso$react).forwardRef($e6afbd83fe6ebbd2$var$FocusableProvider);
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
  var _ref = (0, $h8xso$useFocus)(props),
    focusProps = _ref.focusProps;
  var _ref2 = (0, $h8xso$useKeyboard)(props),
    keyboardProps = _ref2.keyboardProps;
  var interactions = (0, $h8xso$mergeProps)(focusProps, keyboardProps);
  var domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
  var interactionProps = props.isDisabled ? {} : domProps;
  var autoFocusRef = (0, $h8xso$useRef)(props.autoFocus);
  (0, $h8xso$useEffect)(function () {
    if (autoFocusRef.current && domRef.current) (0, $6a99195332edec8b$export$80f3e147d781571c)(domRef.current);
    autoFocusRef.current = false;
  }, [domRef]);
  return {
    focusableProps: (0, $h8xso$mergeProps)(_objectSpread(_objectSpread({}, interactions), {}, {
      tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
    }), interactionProps)
  };
}
export { $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5 as FocusableProvider, $e6afbd83fe6ebbd2$export$4c014de7c8940b4c as useFocusable };